<template>
  <div class="row">
    <div class="col-md-12 mb-4 mt-4">
      <h3> Adicionar Vínculos de Cargos </h3>
    </div>
    <div class="col-md-6 mb-4">
      <label class="form-control-label">Ano Safra</label>
      <multiselect 
        v-model="selectedAnosafras" 
        :options="anosafras" 
        placeholder="Selecione um Ano Safra" 
        label="descricao"
        track-by="id"
        :limit="1"
        :limit-text="limitText"
        multiple
        open-direction="top"
        @remove="AddToDeletionList"
      />
    </div>
    <div class="col-md-6 mb-4" v-for="anosafra in selectedAnosafras">
      <label class="form-control-label">Cargos - {{ anosafra.descricao }}</label>
      <multiselect 
        v-model="selectedJobs[anosafra.id]" 
        :options="jobs"
        placeholder="Escolha um cargo"
        label="label"
        track-by="value"
        :limit="1"
        :limit-text="limitText"
        multiple
        open-direction="top"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, watch, onMounted, computed } from "vue";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import useModel from "@/composables/useModel";

const props = defineProps({
  value: { type: Array, required: true },
  initialData: { type: Array },
  deletionList: { type: Array, default: [] }
});

const emit = defineEmits(["input"])
const limitText = (count) => `+ ${count}`
const { fetchAnosafras, anosafras } = useModel('anosafra', '/api/v1/anosafras');
const selectedAnosafras = ref([])
const selectedJobs = ref({})
const jobs = ref([
  { label: 'Gerente de Negócios', value: 'mkt_manager' },
  { label: 'Gerente de Sementes HF',  value: 'grocery_manager', seed_manager_type: 'grocery' },
  { label: 'Gerente de Sementes Cereais',  value: 'grain_manager', seed_manager_type: 'grain' },
  { label: 'Gerente de Nutrição',  value: 'nutrition_manager', seed_manager_type: 'nutrition' },
  { label: 'Gerente de Irrigação', value: 'irrigation_manager', seed_manager_type: 'irrigation' }
])

const AddToDeletionList = (removedAnosafra) => {
  const persistedAnosafra = props.initialData.find(el => el.anosafra.id == removedAnosafra.id)

  if (!persistedAnosafra) return;

  const currentDeletionList = props.deletionList
  currentDeletionList.push(removedAnosafra)

  emit("update:deletion-list", currentDeletionList)
}

const removeFromDeletionList = (addedAnosafra) => {
  console.log("addedAnosafra: ", addedAnosafra)
  const removedAnosafra = props.deletionList.find(el => el.id == addedAnosafra.id)
  console.log("removedAnosafra: ", removedAnosafra)

  if (!removedAnosafra) return;

  console.log("props.deletionList.filter(el => el.id !== removedAnosafra.id): ", props.deletionList.filter(el => el.id !== removedAnosafra.id))
  emit("update:deletion-list", props.deletionList.filter(el => el.id !== removedAnosafra.id))
}

const initializeFromProps = () => {
  if (!Array.isArray(props.initialData) || props.initialData.length === 0) {
    selectedAnosafras.value = [];
    selectedJobs.value = {};
    return;
  }

  const anosafraMap = {};
  const jobsMap = {};

  props.initialData.forEach(item => {
    if (item && item.anosafra && item.jobs) {
      anosafraMap[item.anosafra.id] = item.anosafra;
      jobsMap[item.anosafra.id] = jobs.value.filter(j => item.jobs.includes(j.value));
    }
  });
  
  selectedAnosafras.value = Object.values(anosafraMap);
  selectedJobs.value = jobsMap;
};

// Watch for external prop changes
watch(() => props.initialData, () => { initializeFromProps() }, { immediate: true });

const structuredData = computed(() => {
  return selectedAnosafras.value.map((el) => {
    if (!selectedJobs.value[el.id]) return []

    return { anosafra: el, jobs: selectedJobs.value[el.id].map(el => el.value) }
  })
})

// Only emit if not syncing
watch(structuredData, (newValue) => { emit("input", newValue) }, { deep: true });
watch(selectedAnosafras, (oldValue, newValue) => { 
  if (oldValue.length > newValue.length) {
    const removedElement = oldValue.find(
      a1Item => !newValue.some(a2Item => a2Item.id === a1Item.id)
    );

    removeFromDeletionList(removedElement)
  }
});

onMounted(() => {
  fetchAnosafras()
})
</script>
